<template>
    <div class="row">
        <div class="col">
            <h2 class="titre">Consultation Suivi</h2>
        </div>
    </div>
    <div v-if="isDataLoading == true" class="row">
        <div class="col">
            <vue-loaders name="ball-beat"></vue-loaders>
        </div>
    </div>
    <div v-else class="row">
        <div class="col">
            <div class="row">
                <div class="col">
                    <div class="row">
                        <div class="col lbl"><label>Activité :</label></div>
                        <div class="col txt">
                            <p v-if="!typeActiviteAfficher"> ... </p>
                            <p v-else> {{ typeActiviteAfficher }} </p>
                        </div>
                    </div>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col lbl"><label>Confidentialité :</label></div>
                    <div class="col txt">
                        <p v-if="!confidentialiteAfficher"> ... </p>
                        <p v-else> {{ confidentialiteAfficher }} </p>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="row">
                    <div class="col lbl"><label>Statut :</label></div>
                    <div class="col txt">
                        <p v-if="!statutAfficher"> ... </p>
                        <p v-else> {{ statutAfficher }} </p>
                    </div>
                  </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <Editor v-model="texteSuivi" editorStyle="height: 320px" :readonly="true">
                        <template #toolbar>
                            <span></span>
                        </template>
                    </Editor>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <div class="row">
                        <div class="col lbl"><label>Secteur :</label></div>
                        <div class="col txt">
                            <p v-if="!secteurAssigneAfficher"> ... </p>
                            <p v-else> {{ secteurAssigneAfficher }} </p>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="row">
                        <div class="col-4 lbl"><label>Intervenant :</label></div>
                        <div class="col txt">
                            <p v-if="!intervenantAfficher"> ... </p>
                            <p v-else> {{ intervenantAfficher }} </p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="row">
                        <div class="col lbl"><label></label></div>
                        <div class="col"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <div class="row">
                        <div class="col lbl"><label>Demandé le :</label></div>
                        <div class="col txt">
                            <p v-if="!creerLe"> ... </p>
                            <p v-else> {{ $commun.formatDateHeure(creerLe) }} </p>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="row">
                        <div class="col lbl"><label>Date complétée :</label></div>
                        <div class="col txt">
                            <p v-if="!completee"> ... </p>
                            <p v-else> {{ $commun.formatDateHeure(completee) }} </p>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="row">
                        <div class="col lbl"><label>Date prévue :</label></div>
                        <div class="col txt">
                            <p v-if="!prevue"> ... </p>
                            <p v-else> {{ $commun.formatDateHeure(prevue) }} </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <div class="row">
                        <div class="col"></div>
                        <div class="col txt">
                            <p> {{ secteurCreateurAfficher }}</p>
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="row">
                        <div class="col-4 lbl"><label>Demandeur :</label></div>
                        <div class="col txt">
                            <p v-if="!creerParDescription"> ... </p>
                            <p v-else> {{ creerParDescription }} </p>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="row">
                        <div class="col lbl"><label></label></div>
                        <div class="col"></div>
                    </div>
                </div>
            </div>
        </div>
    </div> <!---->
</template>

<script>
export default {
  name: 'InformationBasicSuivi',
  props: ['typeActiviteAfficher', 'confidentialiteAfficher', 'statutAfficher', 'texte', 
  'secteurAssigneAfficher', 'intervenantAfficher', 'creerLe', 'completee', 'prevue', 
  'creerParDescription', 'secteurCreateurAfficher', 'isDataLoading'],
  computed: {
    texteSuivi(){
        return this.texte;
    }
  }
}
</script>